module.exports = __webpack_public_path__ + "img/Kasir.c2f3d07c.svg";